import { AvatarType } from 'components/shared/User/Avatar'

export enum ActionType {
  GET_CLIENT = 'GET_CLIENT',
  SET_CLIENT = 'SET_CLIENT',
  POST_CLIENT = 'POST_CLIENT',
  PATCH_CLIENT = 'PATCH_CLIENT',

  GET_CLIENTS = 'GET_CLIENTS',
  SET_CLIENTS = 'SET_CLIENTS',

  GET_ACCOUNT_MANAGERS = 'GET_ACCOUNT_MANAGERS',
  SET_ACCOUNT_MANAGERS = 'SET_ACCOUNT_MANAGERS',
  PATCH_CLIENT_ACCOUNT_MANAGER = 'PATCH_CLIENT_ACCOUNT_MANAGER',

  GET_CENTRA_CLIENTS = 'GET_CENTRA_CLIENTS',
  SET_CENTRA_CLIENTS = 'SET_CENTRA_CLIENTS',

  GET_CLIENTS_OPTIONS = 'GET_CLIENTS_OPTIONS',
  SET_CLIENTS_OPTIONS = 'SET_CLIENTS_OPTIONS',
}

interface ManagerType extends AvatarType {
  id: number
  title: string
}

export interface IClient {
  id: number
  name: string
  logo: any
  email: string
  url: string
  createdAt?: string
  activeTaskCount?: number
  managers?: ManagerType[]
}

export interface IPostClient {
  name: string
  url: string
  logo?: any
}

export interface IPatchClient {
  data: IPostClient
  clientId: string | number
}

export interface ICentraClientUser {
  id: number
  firstName: string
  lastName: string
  avatar: string
  email: string
  title: string
  agencyId: number
  roles: string[]
}

export interface ICentraClientClient {
  id: number
  name: string
  logo: string
}

export interface ICentraClient {
  id: number
  newId: number
  name: string
  logo?: string
  primeManager: ICentraClientUser
  accountManager: ICentraClientUser
  clients: ICentraClientClient[] | null
}

export interface IAccountManager {
  id: number
  firstName: string
  lastName: string
  avatar: string
  email: string
  title: string
  roles: string[]
}

export interface IPatchClientAccountManager {
  clientId: number
  accountManagerId: number
  isAgency: boolean
}
